import { FC } from 'react';
import { SelectMultiple } from './SelectMultiple';
import { useTranslation } from 'react-i18next';
import { UserRole } from '@api/models/enums/UserRole';

interface Props {
  className?: string;
  name: string;
  label?: React.ReactNode;
  disabled?: boolean;
  required?: boolean;
  onChange?: (e: any) => void;
}

export const UserRoleSelect: FC<Props> = ({
  className,
  name,
  label,
  disabled,
  required,
  onChange
}) => {
  const { t } = useTranslation();

  const roles = Object.values(UserRole).filter(
    (role) =>
      role !== UserRole.AdminQcs &&
      role !== UserRole.ExternalManager &&
      role !== UserRole.ExternalWorker &&
      role !== UserRole.ExternalOneTime &&
      role !== UserRole.RemoteToken
  );

  return (
    <SelectMultiple
      className={className}
      name={name}
      label={label}
      disabled={disabled}
      required={required}
      options={roles}
      getOptionId={(role: string) => role}
      getOptionNameFromId={(role: string) => t(`user.role.${role}`)}
      onChange={onChange}
    />
  );
};
